import axios from "../utils/custom-axios";
import { get } from "../utils/custom-storage";
import { GENERAL_ERROR, keys } from "../utils/constants";

const API_URL = process.env.REACT_APP_API_URL;

function GET(path, onSuccess = () => {}, onFailure = () => {}) {
  const apiUrl = API_URL + path;
  const access_token = get(keys.access_token);
  axios({
    url: apiUrl,
    headers: {
      "Content-type": "application/json; charset=utf-8",
      Authorization: access_token,
    },
    data: {},
    method: "GET",
  })
    .then((response) => {
      if (response.status === 200) {
        if (response.data && response.data.data) {
          onSuccess(response.data.data);
        } else {
          onFailure(response);
        }
      }
    })
    .catch((error) => {
      let message = getErrorMessage(error);
      if (!message) {
        message = error.message || GENERAL_ERROR;
      }
      onFailure(message);
    });
}

function DELETE({ path, data, onSuccess = () => {}, onFailure = () => {} }) {
  const apiUrl = API_URL + path;
  const access_token = get(keys.access_token);
  axios
    .delete(apiUrl, data, {
      headers: {
        "Content-type": "application/json; charset=utf-8",
        Authorization: access_token,
      },
    })
    .then((response) => {
      if (response.status === 200) {
        onSuccess();
      } else {
        onFailure(response);
      }
    })
    .catch((error) => {
      let message = getErrorMessage(error);
      if (!message) {
        message = error.message || GENERAL_ERROR;
      }
      onFailure(message);
    });
}

function POST({ path, data, onSuccess, onFailure }) {
  const apiUrl = API_URL + path;
  const access_token = get(keys.access_token);

  axios
    .post(apiUrl, data, {
      headers: {
        "Content-type": "application/json; charset=utf-8",
        Authorization: access_token,
      },
    })
    .then((response) => {
      if (response.status === 200) {
        if (response && response.data) {
          onSuccess(response.data);
        } else {
          onFailure(response);
        }
      }
    })
    .catch((error) => {
      onFailure(getErrorMessage(error));
    });
}

function PATCH({ path, data, onSuccess, onFailure }) {
  const apiUrl = API_URL + path;
  const access_token = get(keys.access_token);
  axios
    .patch(apiUrl, data, {
      headers: {
        "Content-type": "application/json; charset=utf-8",
        authorization: access_token,
      },
    })
    .then((response) => {
      if (response.status === 200) {
        if (response && response.data) {
          onSuccess(response.data);
        } else {
          onFailure(response);
        }
      }
    })
    .catch((error) => {
      onFailure(getErrorMessage(error));
    });
}

const getBlob = async (fileUri) => {
  const resp = await fetch(fileUri);
  const imageBody = await resp.blob();

  return imageBody;
};

const POST_S3 = async ({ url, data, onSuccess, onFailure }) => {
  const imageBody = await getBlob(data);
  fetch(url, {
    method: "PUT",
    body: imageBody,
  })
    .then((response) => {
      const { status } = response || {};
      if (status === 200) {
        onSuccess(response);
      } else {
        onFailure(response);
      }
    })
    .catch((error) => {
      onFailure(error);
    });
};

function getErrorMessage(error) {
  const { response = {} } = error;
  const { data = {} } = response;
  const { message } = data;
  return message || error.message || "Something went wrong!";
}

export { GET, POST, DELETE, PATCH, POST_S3 };
